import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import  type {StatCard} from    '../api/vegApl/technicianModel';
import { GenericConstant } from '../utils/GenericConstant';

const WaveIcon = () => <img src="icons/wave_icon.png" alt="Processing" style={{ width: 24, height: 24, display: 'block' }} />;

export const  TECHNICIANVIEWSTATUS:StatCard[] = [
    {
      title: 'Processing',
      apiFlag:GenericConstant.WORKFLOWPROGRESS,
      pageTitle:"Processing",
      value: 2,
      color: {
         bg: '#F0FBF3',
        text: '#008236',
        subText: '#008236',
        icon: '#2563eb',               // vivid blue
        border: '#59D685',
      },
      icon: WaveIcon
    },
 
    {
      title: 'Idle',
      value: 3,
      apiFlag:GenericConstant.WORKFLOWNOTSTARTED,
      pageTitle:"Idle",
      color: {
         bg: '#FFF0DD',
        text: '#A04607',
        subText: '#A04607',
        icon: '#f59e0b',               // amber-500
        border: '#FFC070',
      },
      icon: AccessTimeRoundedIcon
    },
];

  export const  ProcessingStatus = [
        {
            id: 'processing',
            label: 'Processing',
            count: 2,
            icon: QueryStatsRoundedIcon,
            color: {
                bg: 'rgba(59,130,246,0.08)',    // light blue
                text: '#1f2937',                 // gray-800
                icon: '#1d4ed8',                 // blue-700
                badgeBg: 'rgba(59,130,246,0.12)',
                badgeText: '#1d4ed8',
            },
        },
        {
            id: 'completed',
            label: 'Completed',
            count: 12,
            icon: TrendingUpRoundedIcon,
            color: {
                bg: 'rgba(16,185,129,0.08)',    // light green
                text: '#065f46',                 // emerald-800
                icon: '#059669',                 // emerald-600
                badgeBg: 'rgba(16,185,129,0.14)',
                badgeText: '#047857',
            },
        },
        {
            id: 'not-started',
            label: 'Not Started',
            count: 3,
            icon: AccessTimeRoundedIcon,
            color: {
                bg: 'rgba(245,158,11,0.10)',     // light amber
                text: '#92400e',                  // amber-900
                icon: '#d97706',                  // amber-600
                badgeBg: 'rgba(245,158,11,0.18)',
                badgeText: '#b45309',
            },
        },
    ];